/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrganizationPaymentContractBasicInfoFromJSON, OrganizationPaymentContractBasicInfoToJSON } from './OrganizationPaymentContractBasicInfo';
import { OrganizationPaymentContractPaidInfoFromJSON, OrganizationPaymentContractPaidInfoToJSON } from './OrganizationPaymentContractPaidInfo';
export function GetOrganizationPaymentBillingInfoResponseDataFromJSON(json) {
    return GetOrganizationPaymentBillingInfoResponseDataFromJSONTyped(json, false);
}
export function GetOrganizationPaymentBillingInfoResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        contractBasicInfo: OrganizationPaymentContractBasicInfoFromJSON(json['contract_basic_info']),
        contractPaidInfo: OrganizationPaymentContractPaidInfoFromJSON(json['contract_paid_info'])
    };
}
export function GetOrganizationPaymentBillingInfoResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        contract_basic_info: OrganizationPaymentContractBasicInfoToJSON(value.contractBasicInfo),
        contract_paid_info: OrganizationPaymentContractPaidInfoToJSON(value.contractPaidInfo)
    };
}
